import { Tooltip, Badge } from '@mantine/core';
import { AlertTriangle } from 'react-feather';

interface OverrideWarningProps {
  /**
   * If true, render as a compact icon-only badge for tight row layouts.
   * If false (default), render as a labeled badge for wider contexts like the
   * groups-list-level warning (AC13).
   */
  compact?: boolean;
}

const TOOLTIP_TEXT =
  'This matching includes one or more constraint overrides — review carefully.';

/**
 * "Override saved" warning for `matching_sessions` rows where
 * `user_in_valid = true`. Used in two places (MED-829 / E23-8):
 * - inside the sessions panel on completed rows (AC8 — compact)
 * - at the groups-list level when the most recent sync had an override (AC13)
 */
export function OverrideWarning({ compact = false }: OverrideWarningProps) {
  if (compact) {
    return (
      <Tooltip label={TOOLTIP_TEXT} withArrow multiline w={280}>
        <Badge
          color="warningAmber"
          variant="filled"
          size="sm"
          leftSection={<AlertTriangle size={12} />}
          aria-label="Override saved — review carefully"
        >
          Override
        </Badge>
      </Tooltip>
    );
  }

  return (
    <Tooltip label={TOOLTIP_TEXT} withArrow multiline w={320}>
      <Badge
        color="warningAmber"
        variant="filled"
        leftSection={<AlertTriangle size={14} />}
        aria-label="Override saved — review carefully"
      >
        Override saved
      </Badge>
    </Tooltip>
  );
}
